import "core-js/modules/es.array.map.js";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PackagesListItem from './packages-list-item';
export default function PackagesList(_ref) {
  var packages = _ref.packages;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: packages.map(function (pkg) {
      return /*#__PURE__*/_jsx(PackagesListItem, {
        "package": pkg
      }, pkg.id);
    })
  });
}